import styled from 'styled-components';

const ScrollView = styled.div`
    flex-grow: 1;
    overflow-y: auto;
`;

export default ScrollView;